import { render } from "./SectionPartner.vue?vue&type=template&id=21ba50b1&scoped=true"
import script from "./SectionPartner.vue?vue&type=script&lang=js"
export * from "./SectionPartner.vue?vue&type=script&lang=js"

import "./SectionPartner.vue?vue&type=style&index=0&id=21ba50b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ba50b1"]])

export default __exports__